<template>
    <entity-list
        entity="research"
        :use-events="true"
        api-name="researchRequests"
        :entity-sort="researchSort"
        :events-values="researchPeriods"
        select-all-events
        events-label="Research Periods"
        :entity-archive-headers="archiveHeaders"
        :event-id="eventId"
        :team-id="teamId"
        isArchive
    >
        <template v-slot:[`currentList`]="{ entities, searchTerm, readRoute }">
            <v-data-table
                :headers="archiveHeaders"
                :items="entities"
                :items-per-page="15"
                dense
                class="elevation-1"
                :search="searchTerm"
                :footer-props="{
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                }"
            >
                <template v-slot:[`item.reference`]="{ item }">
                    <router-link :to="{ name: readRoute, params: { id: item.keyId } }" :title="item.reference">
                        {{ item.reference }}
                    </router-link>
                </template>
                <template v-slot:[`item.createdDate`]="{ item }">
                    {{ item.createdDate | luxonSortableDateTime }}
                </template>
            </v-data-table>
        </template>
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
import api from '@/api'
import { sortBy } from 'lodash'
export default {
    name: 'ResearchHomeList',
    components: {
        'entity-list': EntityList,
    },
    props: {
        eventId: {
            type: [String, Number],
            required: false,
        },
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
    data() {
        return {
            researchPeriods: [],
            archiveHeaders: [
                {
                    text: 'Reference',
                    align: 'start',
                    value: 'reference',
                    width: '15%',
                },
                {
                    text: 'Topic',
                    align: 'start',
                    value: 'topic',
                },
                { text: 'Main Team', value: 'teamName', filterable: false, width: '20%' },
                { text: 'Archive Date', value: 'archiveDate', filterable: false, width: '20%' },
            ],
        }
    },
    mounted() {
        this.getResearchPeriods()
    },
    methods: {
        getResearchPeriods() {
            this.isLoading = true
            api.get('researchPeriod/getAll')
                .then(res => {
                    this.researchPeriods = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        researchSort(researchRequests) {
            return sortBy(researchRequests, ['reference'])
        },
    },
}
</script>
